// todo this is workaround for our pipelines limitation to replace NEXT_PUBLIC prefixed env variables during build time.
export const getPublicEnvironmentVariables = () => {
  return {
    apiBaseUrl: process.env.NEXT_PUBLIC_API_BASE_URL,
    apiRoute: process.env.NEXT_PUBLIC_API_API_ROUTE,
    appEnvironment: process.env.NEXT_PUBLIC_APP_ENVIRONMENT,
    companyAdminRoute: process.env.NEXT_PUBLIC_API_COMPANY_ADMIN_ROUTE,
    disableNextPrefetchFeature: process.env.DISABLE_NEXT_PREFETCH_FEATURE,
    membershipRoute: process.env.NEXT_PUBLIC_API_MEMBERSHIP_ROUTE,
    notificationsApiRoute: process.env.NEXT_PUBLIC_API_NOTIFICATIONS_ROUTE,
    ocpApiSubscriptionKey: process.env.NEXT_PUBLIC_OCP_API_SUBSCRIPTION_KEY,
    ocpCompanyAdminSubscriptionKey: process.env.NEXT_PUBLIC_OCP_COMPANY_ADMIN_SUBSCRIPTION_KEY,
    ocpNotificationsApiSubscriptionKey: process.env.OCP_NOTIFICATIONS_API_SUBSCRIPTION_KEY,
    optimizelySiteSecondaryUrl: process.env.OPTIMIZELY_SITE_SECONDARY_URL,
    optimizelySiteUrl: process.env.OPTIMIZELY_SITE_URL,
    profileRoute: process.env.NEXT_PUBLIC_API_PROFILE_ROUTE,
    sentryDSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
    vapidPublicKey: process.env.NEXT_PUBLIC_VAPID_PUBLIC_KEY,
  };
};
